<template>
  <div class="body">
    <img class="Bgc" :src="IscSchedule_2023.bgc" alt="背景图" />
    <div class="nav">
      <div class="navTitle">{{ IscSchedule_2023.title }}</div>
      <div class="navDesc">{{ IscSchedule_2023.desc }}</div>
      <ul class="navList">
        <li
          class="navListLi"
          :class="{
            pitch: pitch === index,
            pitch_first: (pitch + 1) % 3 === index,
            pitch_second: (pitch + 2) % 3 === index
          }"
          v-for="(item, index) in List"
          :key="index"
          @click="toJump(index)"
        >
          <arrow-right-outlined v-if="pitch === index" class="navListLiArr" />
          <div class="navListLiDate">{{ item.date }}</div>
          <div class="navListLiTitle">{{ item.title }}</div>
        </li>
      </ul>
      <div class="navDate" v-if="List[pitch]">
        <div class="navDateNav">
          <div class="navDateSchedule" v-for="(item, index) in List[pitch].list" :key="index">
            <span v-if="item.time" class="navDateScheduleTime">
              {{ item.time }}
            </span>
            <div class="navDateScheduleDot">
              <p v-if="List[pitch].list.length > 1" class="navDateScheduleDotLine"></p>
              <img :src="dot" alt="绿点" />
            </div>
            <div ref="itemTitle" class="navDateScheduleTitle" @click="toJumpPage(item.link)">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onUpdated } from 'vue'
import { getIscSchedule } from '@/api/2023/index.js'
import { IscSchedule_2023 } from '@/mock/2023isc/data.js'
import { ArrowRightOutlined } from '@ant-design/icons-vue'
const dot = 'https://s1.ssl.qhres2.com/static/f7d5824ea303d286.svg'
const List = ref([]) // 相关日程
const pitch = ref(0)
const itemTitle = ref(null)

onBeforeMount(async () => {
  await fetchInfo()
})

onUpdated(() => {
  itemTitle.value.forEach((element) => {
    if (element.offsetHeight > 40) {
      element.style.lineHeight = '24px'
    }
  })
})

function fetchInfo() {
  getIscSchedule()
    .then((res) => {
      List.value = res.data.data
    })
    .catch(() => {})
}
function toJump(index) {
  pitch.value = index
}

function toJumpPage(link) {
  if (link) {
    window.open(link, '_blank')
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}

.pitch {
  background: rgba(0, 171, 122, 0.96);
}

.pitch_first {
  background: rgba(10, 104, 87, 0.9);
}

.pitch_second {
  background: rgba(10, 104, 87, 0.7);
}

.body {
  position: relative;
  min-width: 1280px;
  height: 959px;

  .Bgc {
    float: left;
    width: 100%;
    height: 100%;
  }
}

.nav {
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 1280px;

  &Title {
    font-size: 40px;
    line-height: 32px;
    color: #00ab7a;
  }

  &Desc {
    font-size: 28px;
    line-height: 32px;
    color: rgba(255, 255, 255, 0.6);
    margin: 18px 0 36px;
  }

  &List {
    width: 438px;
    margin: 0;
    border-radius: 40px 0 0;
    overflow: hidden;

    &Li {
      position: relative;
      cursor: pointer;
      padding: 65px 30px 65px 40px;
      list-style: none;
      width: 100%;
      height: 209px;

      &Arr {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 40px;
        color: #ffffff;
      }

      &Date {
        font-size: 24px;
        line-height: 24px;
        color: rgba(255, 255, 255, 0.9);
      }

      &Title {
        font-size: 28px;
        font-weight: bold;
        line-height: 32px;
        color: #ffffff;
        margin-top: 24px;
      }
    }
  }

  &Date {
    position: absolute;
    right: 0;
    bottom: 0px;
    width: 826px;
    height: 627px;
    padding: 70px 130px;
    box-shadow: 0px 4px 10px 0px rgba(0, 31, 138, 0.15);
    background: url('https://p4.ssl.qhimg.com/t01bbf25eaafb1b7174.png') no-repeat;
    background-size: contain;

    &Nav {
      position: relative;
      height: 100%;
      overflow-y: scroll;
    }

    &Schedule {
      // border: 1px solid green;
      display: flex;
      align-items: center;
      min-height: 40px;
      line-height: 40px;
      margin: auto;
      overflow: hidden;

      &Time {
        display: inline-block;
        min-width: 93px;
        text-align: center;
        font-size: 18px;
        color: #8a9099;
      }

      &Dot {
        // border: 1px solid red;
        display: inline-block;
        position: relative;
        width: 18px;
        height: 100%;
        min-height: 18px;
        margin: 0 16px;
        text-align: center;

        &Line {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          // top: 0px;
          // left: 116px;
          width: 1px;
          height: 100%;
          opacity: 0.4;
          border: 1px dashed #00ab7a;
        }
      }

      &Title {
        flex: 1;
        display: inline-block;
        font-size: 16px;
        color: #3d3d3d;
        cursor: pointer;
      }
    }

    &Schedule:first-child {
      .navDateScheduleDotLine {
        top: 20px;
      }
    }
  }
}

// 美化滚动条
.navDateNav {
  margin: 0;
  overflow: overlay;
  transition: 0.3s background-color;
}
</style>
